<script lang="ts">
import { t } from '@/modules/translations'
import { timeFormatter } from '@/utils/date'

import BotAvatar from '../avatars/BotAvatar.svelte'

type Props = {
	createdAt: string
}

let { createdAt }: Props = $props()

let formattedTime = $derived(timeFormatter.format(new Date(createdAt)))
</script>

<BotAvatar />
<span class="ml-2 text-xs break-words overflow-hidden">
	<span class="font-bold">Chatbot</span>
	<span>{$t('systemMessage.chatResolved')}</span>
	<span>{formattedTime}</span>
</span>
